import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { inject, observer } from "mobx-react";
import * as React from "react";
import { withRouter } from "react-router";
import { Col, FormGroup, Label, Row } from "reactstrap";
import EInput from "src/Components/EInput";
import { WellsStore } from "src/Stores/Wells/WellsStore";

@inject('stores')
@observer
class CostTotalHeader extends React.Component {
    public props: any;
    private WellsStore: WellsStore;
    constructor(props: any) {
        super(props);
        this.WellsStore = props.stores.WellsStore;
    }

    public handleInvoiceReadyCheck = () => {
        const wellCloseReview = this.WellsStore.wellCloseReview;
        wellCloseReview.invoiceReady = !wellCloseReview.invoiceReady;
        this.WellsStore.updateWellCloseReview(wellCloseReview);
    }

    public render() {
        const wellCloseReview = this.WellsStore.wellCloseReview;
        if (wellCloseReview === undefined) {
            return '';
        }
        return <div>
        <Row>
            <Col md="2">
                <FormGroup>
                    <Label>Product Total</Label>
                    <EInput
                        disabled={true}
                        type="text"
                        name="productTotal"
                        id="productTotal"
                        data-mask="currency"
                        value={wellCloseReview.productTotal}
                    />
                </FormGroup>
            </Col>
            <Col md="2">
                <FormGroup>
                    <Label>Product Tax</Label>
                    <EInput
                        disabled={true}
                        type="text"
                        name="productTax"
                        id="productTax"
                        data-mask="currency"
                        value={wellCloseReview.productTax}
                        />
                </FormGroup>
            </Col>
            <Col md="2">
                <FormGroup>
                    <Label>EBP Costs</Label>
                    <EInput
                        disabled={true}
                        type="text"
                        name="otherCosts"
                        id="otherCosts"
                        data-mask="currency"
                        value={wellCloseReview.otherCosts}
                        />
                </FormGroup>
            </Col>
            <Col md="2">
                <FormGroup>
                    <Label>EBP Costs Tax</Label>
                    <EInput
                        disabled={true}
                        type="text"
                        name="otherCostTax"
                        id="otherCostTax"
                        data-mask="currency"
                        value={wellCloseReview.otherCostTax}
                    />
                </FormGroup>
            </Col>
            <Col md="1" className="align-center" style={{paddingTop: '2rem'}}>
                <FontAwesomeIcon icon="equals" />
            </Col>
            <Col md="3">
                <FormGroup>
                    <Label>Well Total</Label>
                    <EInput
                        disabled={true}
                        type="text"
                        name="dailyTotal"
                        id="dailyTotal"
                        data-mask="currency"
                        value={wellCloseReview.wellTotal}
                    />
                </FormGroup>
            </Col>
        </Row>
        <Row>
            <Col md="2">
                <FormGroup>
                    <Label>Adjusted Product Total</Label>
                    <EInput
                        disabled={true}
                        type="text"
                        name="productTotal"
                        id="productTotal"
                        data-mask="currency"
                        value={wellCloseReview.adjustedProductTotal}
                    />
                </FormGroup>
            </Col>
            <Col md="2">
                <FormGroup>
                    <Label>Adjusted Product Tax</Label>
                    <EInput
                        disabled={true}
                        type="text"
                        name="productTax"
                        id="productTax"
                        data-mask="currency"
                        value={wellCloseReview.adjustedProductTax}
                    />
                </FormGroup>
            </Col>
            <Col md="2">
                <FormGroup>
                    <Label>Adjusted EBP Costs</Label>
                    <EInput
                        disabled={true}
                        type="text"
                        name="otherCosts"
                        id="otherCosts"
                        data-mask="currency"
                        value={wellCloseReview.adjustedOtherCosts}
                        />
                </FormGroup>
            </Col>
            <Col md="2">
                <FormGroup>
                    <Label>Adjusted EBP Costs Tax</Label>
                    <EInput
                        disabled={true}
                        type="text"
                        name="otherCostTax"
                        id="otherCostTax"
                        data-mask="currency"
                        value={wellCloseReview.adjustedOtherCostTax}
                    />
                </FormGroup>
            </Col>
            <Col md="1" className="align-center" style={{paddingTop: '2rem'}}>
                <FontAwesomeIcon icon="equals" />
            </Col>
            <Col md="3">
                <FormGroup>
                    <Label>Reconciled Well Total</Label>
                    <EInput
                        disabled={true}
                        type="text"
                        name="dailyTotal"
                        id="dailyTotal"
                        data-mask="currency"
                        value={wellCloseReview.adjustedWellTotal}
                    />
                </FormGroup>
            </Col>
        </Row>
        <Row>
            <Col md="3">
                <FormGroup style={{'marginLeft': '1rem', marginTop: '1rem'}} check={true}>
                    <Label check={true} style={{fontSize: '1.25rem'}}>
                        <EInput
                            type="checkbox"
                            name="invoiceReady"
                            id="invoiceReady"
                            checked={wellCloseReview.invoiceReady}
                            onChange={this.handleInvoiceReadyCheck}
                        />
                        {' '} Invoice Ready
                    </Label>
                </FormGroup>
            </Col>
            <Col md="3" />
            <Col md="3">
                <FormGroup>
                    <Label>Total Difference (%)</Label>
                    <EInput
                        disabled={true}
                        type="text"
                        name="otherCostTax"
                        id="otherCostTax"
                        value={wellCloseReview.totalDifferencePercent}
                    />
                </FormGroup>
            </Col>
            <Col md="3">
                <FormGroup>
                    <Label>Total Difference ($)</Label>
                    <EInput
                        disabled={true}
                        type="text"
                        name="otherCostTax"
                        id="otherCostTax"
                        data-mask="currency"
                        value={wellCloseReview.totalDifferenceCost}
                    />
                </FormGroup>
            </Col>
        </Row>
        </div>;
    }
}

export default withRouter(CostTotalHeader);


// WEBPACK FOOTER //
// ./src/Components/Main/WellWorkflow/WellClose/CostsTotalHeader.tsx